const secrets = {
	clientId: "test",
	clientSecret:
		"e572cd23543f8e1b89439d1f6b2619ca67bd5b258d90abfe84bb753be2b6afc46e9ff91bb1d2c8fe3c5b1cd59b05b523d68b66d6f1e74775f974b032056b6c9c",
};

export default secrets;
